import React from "react";
import Footer from "../../components/Footer/Footer";
import Hero from "../../components/Hero/Hero";
import Service from "../../components/Service/Service";
import landing from "../../assets/hero.png";
import LandingCards from "../../components/LandingCards/LandingCards";

const LandingPage = () => {
  const heroConf = {
    title: "WE PROVIDE MANUFACTURING SUPPORT INCLUDING",
    img: landing,
    list: [
      "3D Printing",
      "Laser Cutting",
      "PCB Manufacturing",
      "Silicon Molding",
      "Product Development",
    ],
  };
  return (
    <div className="bg_light">
      <Hero {...heroConf} home={true} />
      {/* <About /> */}
      <LandingCards />
      <Service />
      <Footer />
    </div>
  );
};

export default LandingPage;
